import { useEffect, useState } from "react";
import "../scss/styles.scss";
import "../scss/t.scss";
import LogoSrc from "../assets/logo.png";
import { Link } from "react-router-dom";
import StorageService, { storageService } from "../services/storage.service";
import { Menu, MenuLevel } from "../models/menu.model";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAnglesLeft, faAnglesRight, faListCheck, faCircleInfo, faAtom, faBoxesStacked, faAngleRight, faAngleDown, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faHouse, faCalendarDays, faUser, faListSquares, faFile, faTruck, faPeopleRoof, faCalendar, faVault, faUsers, faFileExport, faChartColumn, faList, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import FaviconSrc from "../assets/Favicon.png"

export const SideNav = () => {
  const { t } = useTranslation();
  const [menu, setMenu] = useState({ menus: [] });
  const user = storageService.getUser();
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [idMenu, setIdMenu] = useState(0);
  const [idSubMenu, setIdSubMenu] = useState('');
  const history = useHistory();
  const [idMouseOver, setIdMouseOver] = useState('');
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

    // Icones para o meu
  /**
   * Sprin3200
   * Foram adicionado o novo icone para o menu do indicador
   */
  const iconMappings = {
    faHouse: faHouse,
    faCalendarDays: faCalendarDays,
    faUser: faUser,
    faListSquares: faListSquares,
    faFile: faFile,
    faTruck: faTruck,
    faPeopleRoof: faPeopleRoof,
    faCalendar: faCalendar,
    faVault: faVault,
    faFileExport: faFileExport,
    faChartColumn: faChartColumn,
    faUsers: faUsers,
    faList: faList,
    faListCheck: faListCheck,
    faCircleInfo:faCircleInfo,
    faAtom: faAtom,
    faBoxesStacked: faBoxesStacked,
    faAngleRight: faAngleRight,
    faAngleDown: faAngleDown,
    faChartLine: faChartLine,
    faThumbsUp: faThumbsUp,
  };

  useEffect(() => {
    // Adiciona um ouvinte de evento para o evento 'homePagePreferenceChanged'
    window.addEventListener('homePagePreferenceChanged', handleHomePagePreferenceChange);

    // Retorna uma função de limpeza para remover o ouvinte de evento quando o componente for desmontado
    return () => {
      window.removeEventListener('homePagePreferenceChanged', handleHomePagePreferenceChange);
    };
  }, []);

  useEffect(() => {
    // Obtém o valor do localStorage e atualiza o estado conforme necessário
    const homePagePreference = parseInt(localStorage.getItem('homePagePreference')) || 0;
    // Atualize o estado ou faça outras ações necessárias com base no valor de homePagePreference
  }, []);

  // Função para lidar com a alteração do valor de homePagePreference no localStorage
  const handleHomePagePreferenceChange = () => {
    const homePagePreference = parseInt(localStorage.getItem('homePagePreference')) || 0;
    // Atualize o estado ou faça outras ações necessárias com base no novo valor de homePagePreference
  };

  useEffect(() => {
    // Obtém o valor do localStorage ou define o valor padrão como a rota inicial
    //const lastRoute = localStorage.getItem("lastRoute") || '/Home';
  
    // Redireciona para a última rota visitada
    //history.push();
  }, [history]);
  

  function handleMenuExpansion() {
    if (isMenuExpanded)
    {
      if (idMenu != 0)
      {
        if (menu.menus.filter(x => x.id == idMenu)[0].route == '')
        {
          setIdMenu(0);
          setIdSubMenu('');
        }
      }
    }
    setIsMenuExpanded(!isMenuExpanded);
  }

  function handleClickHome(e) {
    e.preventDefault(); // Previne o comportamento padrão do link
  
    const profileName = localStorage.getItem('profileName'); // Obtém o profileName do localStorage
    const homePagePreference = parseInt(localStorage.getItem('homePagePreference')) || 0;
    const defaultRoute = homePagePreference === 0 && profileName === 'operator' 
    ? '/DashboardBranch' 
    : (homePagePreference === 0 
        ? '/home' 
        : '/DashboardBranch');
  
    // Verifica se o profileName é "approver" e define a rota para /ApproverPickup
    if (profileName === 'approver') {
      console.log('Profile Name: ' + profileName);
      if (!window.location.hash.toLowerCase().includes('/approverpickup')) {
        setIdMenu(3); // Define o idMenu para a rota do Aprovador
        setIdSubMenu('');
        history.push('/ApproverPickup');
      } else {
        window.location.reload();
      }
    } else {
      // Caso o profileName não seja "approver", executa a lógica original
      if (window.location.hash.toLowerCase().includes(defaultRoute.toLowerCase())) {
        window.location.reload();
      } else {
        // Verifica o valor de homePagePreference e define o idMenu com base nesse valor
        if (homePagePreference === 0) {
          setIdMenu(1); // Define o idMenu como 1 se homePagePreference for 0
        } else if (homePagePreference === 1) {
          setIdMenu(2); // Define o idMenu como 2 se homePagePreference for 1
        } else {
          setIdMenu(0); // Define o idMenu como 0 para outros valores de homePagePreference
        }
        setIdSubMenu('');
        history.push(defaultRoute);
      }
    }
  }
  

  function selectIdMenu(id: number) {
    if (idMenu !== id) {
      setIdMenu(id);
    } else {
      setIdMenu(0);
      setIdSubMenu('');
    }
  
  }
  

  function selectIdSubmenu(id: string)
  {
    setIdSubMenu(id);    
  }

  useEffect((): any => {
    var menus = StorageService.getSideNavMenus();
    setMenu({ menus: menus });
  }, []);

  useEffect((): any => {
  }, [idMenu]);

  function verificaMenu(subItem) {
    let className = '';

    if (subItem.idPai === idMenu) {
      className = "sub-menu is-open";
      if (!isMenuExpanded)
        setIsMenuExpanded(true);
    }
    else {
      className = "sub-menu";
    }

    return className;
  }

  return (
    <>
      <div className="border-end bg-white" id="sidebar-wrapper">
        <div className={'sidebar-heading-retracted text-center'}>
          {/* Sprint 31 - Melhoria de lyout - Mudança da cor da linha do navbar e sua espessura*/}
          <div style={{borderBottom: '2px solid #073F7C', height: isMenuExpanded ? '57px' : '57px'}}>
            <Link
             to={(() => {
              if (user?.profile.profileName === "approver") {
                return "/ApproverPickup";
              } else if (user?.profile.profileName === "operator") {
                return "/DashboardBranch";
              } else {
                return "/Home";
              }
            })()}
            style={{ textDecoration: 'none', textAlign: 'center', width: '100%', height: '40px' }}
            onClick={(e) => {
              handleClickHome(e);
            }}
            >
              <img 
                src={FaviconSrc} 
                alt="Ícone" 
                className="p-2 sideBarIcon text-light" 
                style={{ width: '43px', height: '30px', marginTop: isMenuExpanded ? '12px' : '0px' }} 
              />
            </Link>
            <br />
            {!isMenuExpanded && (
              <FontAwesomeIcon 
                icon={faAnglesRight} 
                className="p-2 pt-0 sideBarIcon" 
                onClick={(e) => { handleMenuExpansion(); }} 
              />
              )}          
          </div>
          <div>
            {menu.menus.map((item: Menu, idx) => (
              <span key={idx}>
                <Link to={item.route !== '' ? "/" + item.route : '#'}>
                  <div
                    onClick={() =>
                      selectIdMenu(item.id)
                    }
                    onMouseEnter={() => setIdMouseOver(item.id.toString())}
                    onMouseLeave={() => setIdMouseOver('')}
                    className={`list-group-item ${item.id.toString() == idMouseOver ? 'list-group-item-selected' : ''} p-3 ${item.id == idMenu ? "itemActive" : ""}`}
                    style={{height: t(item.title).length >= 30 ? '70px' : '52px', border: '0px'}}                          
                  >
                    <FontAwesomeIcon icon={iconMappings[item.icon] || faUser} title={t(item.title)} />                    
                  </div>
                </Link>
                {item.route === '' && item.subItem.map((subItem: MenuLevel, idx) => (
                    <ul className={verificaMenu(subItem)} key={idx}>
                      <li className="liMenu" style={{padding: '0px', paddingRight: '0.5px'}}>
                        <Link
                          onMouseEnter={() => setIdMouseOver(subItem.id.toString())}
                          onMouseLeave={() => setIdMouseOver('')}      
                          className={`list-group-item ${subItem.id.toString() == idMouseOver ? 'list-group-item-selected' : ''} p-3 ${subItem.id == idSubMenu ? "itemActive" : ""}`}
                          to={"/" + subItem.route}
                          style={{height: t(subItem.title).length >= 30 ? '70px' : '52px', border: '0px'}}
                          onClick={() =>
                            selectIdSubmenu(subItem.id)
                          }>
                          {/*<FontAwesomeIcon icon={iconMappings[subItem.icon] || faUser} title={t(subItem.title)} />*/}                          
                        </Link>
                      </li>
                    </ul>
                  ))}
              </span>
          ))}
          </div>
        </div>
        {isMenuExpanded && <div className={'sidebar-heading'}>
          {/* Sprint 31 - Melhoria de lyout - Mudança da cor da linha do navbar e sua espessura*/}
          <div className="pl-4 pr-4" style={{display: 'flex', borderBottom: '2px solid #073F7C', height: '57px'}}>
            <Link
               to={(() => {
                if (user?.profile.profileName === "approver") {
                  return "/ApproverPickup";
                } else if (user?.profile.profileName === "operator") {
                  return "/DashboardBranch";
                } else {
                  return "/Home";
                }
              })()}
              style={{ textDecoration: 'none', textAlign: 'center', width: '100%', height: '40px' }}
              onClick={(e) => {
                handleClickHome(e);
              }}
            >
              <img src={LogoSrc} width="110px" alt="Logo Brinks" style={{marginTop: '12px'}}/>
            </Link>

            <FontAwesomeIcon icon={faAnglesLeft} className="sideBarIcon pt-2" onClick={(e) => { handleMenuExpansion(); }} style={{marginTop: '10px'}}/>
          </div>
          <div style={{width: '220px'}}>
            {menu.menus.map((item: Menu, idx) => (
              <span key={idx}>
                <Link to={item.route !== '' ? "/" + item.route : '#'}>
                  <div
                    onClick={() =>
                      selectIdMenu(item.id)
                    }
                    onMouseEnter={() => setIdMouseOver(item.id.toString())}
                    onMouseLeave={() => setIdMouseOver('')}                    
                    className={`list-group-item ${item.id.toString() == idMouseOver ? 'list-group-item-selected' : ''} p-3 ${item.id == idMenu ? "itemActive" : ""}`}
                    style={{height: t(item.title).length >= 30 ? '70px' : '52px', border: '0px'}}
                          
                  >
                    <label>{t(item.title)}</label>
                    {item.route == '' && <FontAwesomeIcon style={{position: 'absolute', right: '10px'}} icon={idMenu == item.id ? faAngleDown : faAngleRight} />}
                  </div>
                </Link>
                {item.route === '' && item.subItem.map((subItem: MenuLevel, idx) => (
                    <ul className={verificaMenu(subItem)} key={idx}>
                      <li className="liMenu" style={{padding: '0px'}}>
                        <Link
                          onMouseEnter={() => setIdMouseOver(subItem.id.toString())}
                          onMouseLeave={() => setIdMouseOver('')}                              
                          className={`list-group-item ${subItem.id.toString() == idMouseOver ? 'list-group-item-selected' : ''} p-3 ${subItem.id == idSubMenu ? "itemActive" : ""}`}
                          to={"/" + subItem.route}
                          style={{height: t(subItem.title).length >= 30 ? '70px' : '52px', border: '0px'}}
                          onClick={() =>
                            selectIdSubmenu(subItem.id)
                          }>
                          <label className="pl-3">{t(subItem.title)}</label>
                        </Link>
                      </li>
                    </ul>
                  ))}
              </span>
          ))}
          </div>          
        </div>}
      </div>
      {/*
      <div className="border-end bg-white" id="sidebar-wrapper" style={isMenuExpanded ? {} : { width: '3.1rem' }}>
        <div className={`sidebar-heading${isMenuExpanded ? '' : '-retracted'}`}>
          <Link
            to={user?.profile.profileName === "operator" ? "/DashboardBranch" : "/Home"}
            style={{ textDecoration: 'none', textAlign: 'center', width: '100%' }}
            onClick={(e) => {
              handleClickHome(e);
            }}
          >
            <FontAwesomeIcon icon={faAtom} className="p-0 sideBarIcon text-light" />
            {isMenuExpanded && ( <img src={LogoSrc} width="110px" alt="Logo Brinks" /> )}
          </Link>
          
          {isMenuExpanded ? (
            <FontAwesomeIcon icon={faAnglesLeft} className="sideBarIcon" onClick={(e) => { handleMenuExpansion(); }} />
          ):(
            <div><FontAwesomeIcon icon={faAnglesRight} className="sideBarIcon-retracted" onClick={(e) => { handleMenuExpansion(); }} /></div>  
          )}
          
        </div>
        <div className={`list-group${isMenuExpanded ? '' : '-retracted'} list-group-flush`}>
          {menu.menus.map((item: Menu, idx) => (
            <span key={idx}>
              {item.route !== '' &&
                <Link
                  to={"/" + item.route}
                >
                  <div
                    onClick={() =>
                      setIdMenu(item.id)
                    }
                    className={`list-group-item list-group-item-action p-3 ${window.location.hash.toLowerCase().includes("/" + item.route.toLowerCase()) ? "itemActive" : ""}`}
                  >
                    {isMenuExpanded ? (
                      <label>{t(item.title)}</label>
                    ):(
                      <FontAwesomeIcon icon={iconMappings[item.icon] || faUser} title={t(item.title)} />
                    )}
                  </div>

                  {item.subItem.map((subItem: MenuLevel, idx) => (
                    <ul className={verificaMenu(subItem)}>
                      <li className="liMenu">
                        <Link
                          className="list-group-item list-group-item-action p-3"
                          to={"/" + subItem.route}
                        >
                          <label className="labelWhite">{t(subItem.title)}</label>
                        </Link>
                      </li>
                    </ul>
                  ))}
                </Link>
              }
              {item.route === '' &&
                <>
                  <div
                    onClick={() =>
                      setIdMenu(item.id)
                    }
                    className={`list-group-item list-group-item-action p-3`}
                  >
                    {isMenuExpanded ? (
                      <label>{t(item.title)}</label>
                    ):(
                      <FontAwesomeIcon icon={iconMappings[item.icon] || faUser} title={t(item.title)} />
                    )}
                  </div>

                  {item.subItem.map((subItem: MenuLevel, idx) => (
                    <ul className={verificaMenu(subItem)} key={idx}>
                      <li className="liMenu">
                        <Link
                          className="list-group-item list-group-item-action p-3"
                          to={"/" + subItem.route}
                        >
                          {isMenuExpanded ? (
                            <label className="labelWhite">{t(subItem.title)}</label>
                          ):(
                            <FontAwesomeIcon icon={iconMappings[subItem.icon] || faUser} title={t(subItem.title)} />
                          )}
                        </Link>
                      </li>
                    </ul>
                  ))}
                </>
              }
            </span>
          ))}
        </div>
        </div>*/}
    </>
  );
};
